/**
 * @file お問い合わせフォームのバリデーション
 *
 */
'use strict';
import fetchJsonp from 'fetch-jsonp';
import Common from '../../util/_common';

/**
 * @classname FormEntryValidateView
 * @classdesc お問い合わせフォームのバリデーション
 */
export default class FormEntryValidateView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 送信ボタン
	 */
	constructor($e) {
		console.log('FormEntryValidateView.constructor');
		this._$e = $e;
		this._submit_state = true;
		this._postal_code_state1 = false;
		this._postal_code_state2 = false;
		this._$form = $('#form-recruitment');
		this._$your_name = $('#your-name');
		this._$your_name_kana = $('#your-name-kana');
		this._$your_postal_code1 = $('#your-postal-code-1');
		this._$your_postal_code2 = $('#your-postal-code-2');
		this._$your_address1 = $('#your-address-1');
		this._$your_address2 = $('#your-address-2');
		this._$your_address3 = $('#your-address-3');
		this._$your_telephone = $('#your-telephone');
		this._$your_email = $('#your-email');
		this._$your_email_confirm = $('#your-email-confirm');
		this._$your_birthday1 = $('#your-birthday-1');
		this._$your_birthday2 = $('#your-birthday-2');
		this._$your_birthday3 = $('#your-birthday-3');
		this._$your_entry_category = $('#your-entry-category');
		this._$your_message = $('#your-message');
		this._$e.on('click', () => this.onClick());
		this.formInit();
	};

	/**
	 * 送信ボタンクリックイベントのコールバック
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	formInit() {
		console.log('FormEntryValidateView.formInit')
		this._$form.attr('action', '/recruitments/entry_complete/');
		this._$your_name.on('blur', () => this.checkEmpty(this._$your_name));
		this._$your_name_kana.on('blur', () => this.checkYourNameKana());
		this._$your_postal_code1.on('blur', () => this.checkYourPostalCode1());
		this._$your_postal_code2.on('blur', () => this.checkYourPostalCode2());
		this._$your_address1.on('blur', () => this.checkEmpty(this._$your_address1));
		this._$your_address2.on('blur', () => this.checkEmpty(this._$your_address2));
		this._$your_address3.on('blur', () => this.checkEmpty(this._$your_address3));
		this._$your_telephone.on('blur', () => this.checkYourTelephone());
		this._$your_email.on('blur', () => this.checkYourEmail());
		this._$your_email_confirm.on('blur', () => this.checkYourEmailConfirm());
		this._$your_birthday1.on('change', () => this.checkEmpty(this._$your_birthday1, true));
		this._$your_birthday2.on('change', () => this.checkEmpty(this._$your_birthday2, true));
		this._$your_birthday3.on('change', () => this.checkEmpty(this._$your_birthday3, true));
		this._$your_entry_category.on('change', () => this.checkEmpty(this._$your_entry_category, true));
		this._$your_message.on('blur', () => this.checkEmpty(this._$your_message));
	}

	/**
	 * 送信ボタンクリックのコールバック
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	onClick() {
		console.log('FormEntryValidateView.onClick');
		this._submit_state = true;
		let checkAll = new Promise((resolve, reject) => {
			this.checkEmpty(this._$your_name);
			this.checkYourNameKana();
			this.checkEmpty(this._$your_postal_code1);
			this.checkEmpty(this._$your_postal_code2);
			this.checkEmpty(this._$your_address1);
			this.checkEmpty(this._$your_address2);
			this.checkEmpty(this._$your_address3);
			this.checkYourTelephone();
			this.checkYourEmail();
			this.checkYourEmailConfirm();
			this.checkEmpty(this._$your_birthday1, true);
			this.checkEmpty(this._$your_birthday2, true);
			this.checkEmpty(this._$your_birthday3, true);
			this.checkEmpty(this._$your_entry_category, true);
			this.checkEmpty(this._$your_message);
			resolve();
		});
		checkAll.then(() => {
			console.log(this._submit_state)
			if(this._submit_state) this._$form.trigger('submit');
			this._submit_state = true;
		});
	}

	/**
	 * バリデーション - フリガナ
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourNameKana() {
		console.log('FormEntryValidateView.checkYourNameKana');
		if(!this._$your_name_kana.val()) {
			this.showErrorTip(this._$your_name_kana, '入力してください');
		} else {
			if(!this._$your_name_kana.val().match(/^[ァ-ヾ０-９－\s　！”＃＄％＆’（）＝～｜‘｛＋＊｝＜＞？＿－＾￥＠「；：」、。・]+$/)){
				this.showErrorTip(this._$your_name_kana, 'カタカナで入力してください');
			} else {
				this.hideErrorTip(this._$your_name_kana);
			}
		}
	}

	/**
	 * バリデーション - 郵便番号1
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourPostalCode1() {
		console.log('FormEntryValidateView.checkYourPostalCode1');
		console.log(`${this._$your_postal_code1.val()}-${this._$your_postal_code2.val()}`);
		console.log(this._$your_postal_code1.val().length);
		const regexp_num = /^[0-9]{3}$/;
		if(!this._$your_postal_code1.val()) {
			this.showErrorTip(this._$your_postal_code1, '入力してください');
			this._postal_code_state1 = false;
		} else {
			if(!regexp_num.test(this._$your_postal_code1.val())) {
				this.showErrorTip(this._$your_postal_code1, '半角数字3桁で入力してください');
				this._postal_code_state1 = false;
			} else {
				this.hideErrorTip(this._$your_postal_code1);
				this._postal_code_state1 = true;
				if(!this._$your_postal_code2.val()){ return }
				console.log(`code1: ${this._postal_code_state1} / code2: ${this._postal_code_state2}`);
				if(this._postal_code_state2) this.insertAddress();
			}
		}
	}
	
	/**
	 * バリデーション - 郵便番号2
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourPostalCode2() {
		console.log('FormEntryValidateView.checkYourPostalCode2');
		console.log(`${this._$your_postal_code1.val()}-${this._$your_postal_code2.val()}`);
		const regexp_num = /^[0-9]{4}$/;
		if(!this._$your_postal_code2.val()) {
			this.showErrorTip(this._$your_postal_code2, '入力してください');
			this._postal_code_state2 = false;
		} else {
			if(!regexp_num.test(this._$your_postal_code2.val())) {
				this.showErrorTip(this._$your_postal_code2, '半角数字4桁で入力してください');
				this._postal_code_state2 = false;
			} else {
				this.hideErrorTip(this._$your_postal_code2);
				this._postal_code_state2 = true;
				if(!this._$your_postal_code1.val()){ return }
				console.log(`code1: ${this._postal_code_state1} / code2: ${this._postal_code_state2}`);
				if(this._postal_code_state1) this.insertAddress();
			}
		}
	}
	
	/**
	 * 郵便番号から住所を自動挿入する
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	insertAddress() {
		console.log('FormEntryValidateView.insertAddress');
		const api = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=';
		const url = api + this._$your_postal_code1.val() + this._$your_postal_code2.val();
		console.log(`${this._$your_postal_code1.val()}-${this._$your_postal_code2.val()}`);
		fetchJsonp(url, {mode: 'cors'})
			.then(response => response.json())
			.then(data => {
				this._$your_address1.val(data.results[0].address1);
				this._$your_address2.val(data.results[0].address2 + data.results[0].address3);
				this.hideErrorTip(this._$your_address1);
				this.hideErrorTip(this._$your_address2);
			}).catch(() => {
				this.showErrorTip(this._$your_postal_code2, '存在しない郵便番号です');
				this._$your_address1.val('');
				this._$your_address2.val('');
			});
	}

	/**
	 * バリデーション - 電話番号
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourTelephone() {
		console.log('FormEntryValidateView.checkYourTelephone');
		const regexp_num = /^[0-9]+$/;
		if(!this._$your_telephone.val()) {
			this.showErrorTip(this._$your_telephone, '入力してください');
		} else {
			if(!regexp_num.test(this._$your_telephone.val())){
				this.showErrorTip(this._$your_telephone, '半角数字のみで入力してください');
			} else {
				this.hideErrorTip(this._$your_telephone);
			}
		}
	}

	/**
	 * バリデーション - メールアドレス
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourEmail() {
		console.log('FormEntryValidateView.checkYourEmail');
		if(!this._$your_email.val()) {
			this.showErrorTip(this._$your_email, '入力してください');
		} else {
			if(!this._$your_email.val().match(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i)){
				this.showErrorTip(this._$your_email, 'メールアドレスが不正です');
			} else {
				this.hideErrorTip(this._$your_email);
			}
		}
	}

	/**
	 * バリデーション - 確認用メールアドレス
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourEmailConfirm() {
		console.log('FormEntryValidateView.checkYourEmailConfirm');
		if(!this._$your_email_confirm.val()) {
			this.showErrorTip(this._$your_email_confirm, '入力してください');
		} else {
			if(this._$your_email_confirm.val() !== this._$your_email.val()) {
				this.showErrorTip(this._$your_email_confirm, 'メールアドレスが一致しません');
			} else {
				this.hideErrorTip(this._$your_email_confirm);
			}
		}
	}

	/**
	 * バリデーション - 生年月日 - 年
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourBirthday1() {
		console.log('FormEntryValidateView.checkYourBirthday1');
		if(!this._$your_birthday1.val()) {
			this.showErrorTip(this._$your_birthday1, '選択してください');
			this._birthday_state1 = false;
		} else {
			this.hideErrorTip(this._$your_birthday1);
			this._birthday_state1 = true;
		}
	}

	/**
	 * バリデーション - 生年月日 - 月
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourBirthday2() {
		console.log('FormEntryValidateView.checkYourBirthday2');
		if(!this._$your_birthday2.val()) {
			this.showErrorTip(this._$your_birthday2, '選択してください');
			this._birthday_state2 = false;
		} else {
			this.hideErrorTip(this._$your_birthday2);
			this._birthday_state2 = true;
		}
	}

	/**
	 * バリデーション - 生年月日 - 日
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkYourBirthday3() {
		console.log('FormEntryValidateView.checkYourBirthday3');
		if(!this._$your_birthday3.val()) {
			this.showErrorTip(this._$your_birthday3, '選択してください');
			this._birthday_state3 = false;
		} else {
			this.hideErrorTip(this._$your_birthday3);
			this._birthday_state3 = true;
		}
	}

	/**
	 * バリデーション - 共通：エンプティ
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	checkEmpty(__$e, select = false) {
		if(!__$e.val()) {
			this.showErrorTip(__$e, select ? '選択してください' : '入力してください');
		} else {
			this.hideErrorTip(__$e);
		}
	}

	/**
	 * error-tip表示
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	showErrorTip($form_parts, error_text) {
		$form_parts.closest('dl').find('.error-tip').addClass('show');
		$form_parts.closest('dl').find('.error-tip-inner').text(error_text);
		this._submit_state = false;
	}

	/**
	 * error-tip非表示
	 *
	 * @memberof FormEntryValidateView
	 * @return {undefined}
	 */
	hideErrorTip($form_parts) {
		$form_parts.closest('dl').find('.error-tip').removeClass('show');
		$form_parts.closest('dl').find('.error-tip-inner').text('');
	}

}
